/** Languages the game ships in. Shared so the Worker can validate what the client reports. */
export const LOCALES = ["zh-Hant", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export const isLocale = (x: unknown): x is Locale =>
  typeof x === "string" && (LOCALES as readonly string[]).includes(x);

/** First preferred language decides: any zh* (Traditional or not) plays the zh-Hant edition, everything else English. */
export function localeFromLanguages(langs: readonly string[]): Locale {
  const first = langs.find((l) => l.trim() !== "");
  return first?.toLowerCase().startsWith("zh") ? "zh-Hant" : "en";
}
